module.exports = __webpack_public_path__ + "static/media/layer-4.e534a996.png";